import { css } from 'styled-components'

export const resetInput = css`
  background: none;
  outline: none;
  border: none;
`



// WEBPACK FOOTER //
// ./src/utils/form.js